// Run summary bar: step / time / commit / abort / version counts, plus the
// active lane-filter chip (when a lifeline is selected).

import type { RunResult } from "../../src/backend/interp/interpreter.js";

interface SummaryProps {
  result: RunResult;
  filterLabel: string | null;
  onClearFilter(): void;
}

export function Summary({ result, filterLabel, onClearFilter }: SummaryProps) {
  return (
    <div id="summary">
      <span>{result.steps} steps</span>
      <span>t={result.finalTime.toFixed(2)}</span>
      <span className="good">{result.commits} commits</span>
      <span className="bad">{result.aborts} aborts</span>
      <span>{result.store.versionCount()} versions</span>
      {filterLabel !== null && (
        <button className="filter-chip" title="clear filter (Esc)" onClick={onClearFilter}>
          filtering <b>{filterLabel}</b> ✕
        </button>
      )}
    </div>
  );
}
